module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "panel"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c4a62436!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/panels/Panel.vue
// module id = 712
// module chunks = 1